import { get } from '@core/api/baseApi';

export interface Root {
  referrersStatistics: ReferrersStatistics;
}

export interface ReferrersStatistics {
  success: boolean;
  error: any;
  result: PaginatedResult;
}

export interface PaginatedResult {
  page: number;
  pageCount: number;
  totalCount: number;
  next: any;
  items: UserStatistics[];
}

export interface UserStatistics {
  modalities: Modalities;
  entityName: string;
  entityId: string;
  userProfilePhoto?: string;
}

export type Modalities = Record<string, number>;

interface ReferrersStatisticsFilters {
  startDate: Date;
  endDate: Date;
  pageSize?: number;
  pageNumber?: number;
  sortOrder?: string;
  selectedIdentityId?: string;
  branchId?: number;
  modalityId?: number;
}

interface ApiParams extends Omit<ReferrersStatisticsFilters, 'selectedIdentityId'> {
  selectedIdentityId?: string;
  groupId?: string;
}

export const getReferrersStatistics = async (filters: ReferrersStatisticsFilters): Promise<ReferrersStatistics> => {
  const params: ApiParams = { ...filters };
  
  if (params.selectedIdentityId && params.selectedIdentityId.startsWith('group:')) {
    const groupId = params.selectedIdentityId.substring(6); 
    delete params.selectedIdentityId;
    params.groupId = groupId;
  }
  
  return await get(`/studies/authorized-referral/metrics`, { params });
};
